module.exports = __webpack_public_path__ + "static/certificat-coherence-1b878aaaf15093f4b0459b4b060a51f3.jpg";